import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Typography, Tooltip, type IDropdownItem } from 'shared/ui'
import styles from './styles.module.scss'

export const RequestAuditLogsEventTypesTrigger = observer(
  ({
    selectedEventTypes,
    isSelectAllEvents,
  }: {
    selectedEventTypes: IDropdownItem[]
    isSelectAllEvents: boolean
  }) => {
    const visibleItems = selectedEventTypes.slice(0, 1)
    const tooltipItems = selectedEventTypes.slice(1)

    if (!selectedEventTypes.length) {
      return (
        <div className={styles.emptyWrap}>
          <Typography
            color={'var(--content-primary-disabled)'}
            variant={'body-md-regular'}
            ariaLabel={'placeholder'}
          >
            Select filter
          </Typography>
        </div>
      )
    }

    if (isSelectAllEvents) {
      return (
        <div className={styles.emptyWrap}>
          <Typography variant={'text-input-field-r'} ariaLabel={'allSelected'}>
            All events
          </Typography>
        </div>
      )
    }

    return (
      <div className={classNames(styles.trigger)}>
        {visibleItems.map((item) => (
          <div className={styles.triggerContentWrap} key={item.id}>
            <div className={styles.info}>
              <Typography
                ariaLabel={'eventTypeName'}
                color={'var(--content-primary-primary)'}
                variant={'body-md-regular'}
                ellipsis
              >
                {item.label}
              </Typography>
            </div>
          </div>
        ))}
        {!!tooltipItems.length && (
          <Tooltip
            label={
              <div className={styles.tooltipItems}>
                {tooltipItems.map((item) => (
                  <div key={item.id}>{item.label}</div>
                ))}
              </div>
            }
            placement='top'
          >
            <div className={styles.remainderCount}>+{tooltipItems.length}</div>
          </Tooltip>
        )}
      </div>
    )
  }
)
